import { Link } from "react-router-dom";
import type { Episode } from "@/types/episode";
import { useFavorites } from "@/hooks/useFavorites";

interface EpisodeCardProps {
  episode: Episode;
  index?: number;
}

export default function EpisodeCard({ episode, index = 0 }: EpisodeCardProps) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const favorited = isFavorite(episode.id);

  return (
    <article
      className="group relative rounded-lg overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-500/60 transition-colors duration-300 anim-fade-up"
      style={{ animationDelay: `${Math.min(index, 8) * 45}ms` }}
    >
      <Link to={`/detail/${episode.id}`} className="block cursor-pointer">
        <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-900">
          <img
            src={episode.cover}
            alt={`朋友的妈妈4 ${episode.title} 剧照封面`}
            title={`朋友的妈妈4 ${episode.title} 在线观看与剧情介绍`}
            className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/20 to-transparent opacity-90" />
          <span className="absolute top-2 left-2 px-2 h-6 rounded-md bg-background-950/80 backdrop-blur text-[11px] font-label tracking-wider text-accent-500 flex items-center">
            EP {String(episode.number).padStart(2, "0")}
          </span>
          <div className="absolute inset-x-0 bottom-0 p-3">
            <h3 className="text-sm font-medium leading-5 text-foreground-950 line-clamp-2">
              {episode.title}
            </h3>
            <p className="mt-1 text-[11px] text-foreground-500">{episode.duration}</p>
          </div>
        </div>
      </Link>

      <button
        type="button"
        aria-label={favorited ? "取消收藏" : "收藏该集"}
        onClick={() => toggleFavorite(episode.id)}
        className={`absolute top-2 right-2 w-8 h-8 rounded-md flex items-center justify-center backdrop-blur transition-colors cursor-pointer ${
          favorited
            ? "bg-primary-500 text-background-50"
            : "bg-background-950/70 text-foreground-800 hover:text-primary-400"
        }`}
      >
        <i className={favorited ? "ri-heart-fill text-sm" : "ri-heart-line text-sm"} />
      </button>
    </article>
  );
}